import { useContext } from "react";
import { Text } from "../../components/text/text";
import { LocaleContext } from "../../contexts/locale/locale";
import { Page } from "../page/page";

export const Terms = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<Page title={texts.terms.hero.title} image="/images/home.jpg">
			<Text
				title={texts.terms.hero.title}
				paragraphs={texts.terms.paragraphs}
			/>
		</Page>
	);
};
